import { isRejectedWithValue } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

import { isReportedAuthError } from './authRecovery';
import { recoverFromAuthFailure } from './handleSessionExpired';

import type { Middleware } from '@reduxjs/toolkit';

// SpecRef: ARCH-005 — capture point for data-fetch failures. RTK Query has no
// global error callback, so we listen for rejected endpoint actions; it surfaces
// every query/mutation error via `rejectWithValue`. Auth failures are the one
// exception: they carry their own dedicated event (see `authRecovery`), so
// re-capturing them here would report a single session loss once per failing
// endpoint and bury the reason under generic fetch noise.
export const rtkQueryErrorLogger: Middleware = () => next => action => {
  if (isRejectedWithValue(action)) {
    // Backstop recovery seam (TMDXNC-52). `createFetchWithAuthBaseQuery` and
    // `asQueryFnResult` already call this at the throw site; catching it again
    // here covers any future endpoint with a hand-rolled `queryFn` that bypasses
    // both. Every reaction it can trigger is guarded to one action per page load,
    // so the duplicate call is a no-op.
    recoverFromAuthFailure(action.payload);

    if (!isReportedAuthError(action.payload)) {
      Sentry.captureException(action.payload);
    }
  }
  return next(action);
};
